angular.module("variazioneAnagSoc.components", []).component("variazioneAnagSoc", {
    templateUrl: "ng/components/variazioneAnagSoc/variazioneDataAnagSoc.view.html",
    bindings: {
        richiestePostVendita: "<"
    },
    controllerAs: "variazioneAnagSocCtrl",
    controller: function VariazioneAnagSoc(
        $location,
        $modalService,
        $arcService,
        $RichiestePostVenditaService,
        $rootScope,
        RichiestePostVendita,
        Contratti
    ) {
        var self = this;

        self.$onInit = function () {
            self.validation = {
                checkListUpload: false,
                requestData: false

            }
            self.showMapInfo = false;
            self.mapInfo = "";

            if (self.richiestePostVendita.viewIndex == 0) {
                self.richiestePostVendita.viewIndex = 1050;
            }
            self.visibleDownloadChecklist = true;
            self.visibleUploadChecklist = true;
            var contratti = [];
            if (self.richiestePostVendita.metadata.variazioneAnagrafica.contratti.length == 0) {
                contratti.push(Contratti.build({
                    numero: self.richiestePostVendita.metadata.ctrRichiestaList[0].numeroContratto,
                    modulo: self.richiestePostVendita.metadata.ctrRichiestaList[0].numeroModulo
                }));

                self.richiestePostVendita.metadata.variazioneAnagrafica.contratti = contratti;
            }

            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1' || self.richiestePostVendita.readOnly) {
                self.popolateCheckListDownload();
                self.popolateCheckListUpload();
            }

            retrieveStepInfo();
        };

        self.popolateCheckListDownload = function () {
            self.restDownloadRunning = true;
            $arcService.downloadDocumentationRichiestaPostVendita(self.richiestePostVendita)
                .then(function (response) {
                    self.listOfDocumentDownload = response.listDocuments;
                    self.visibleDownloadChecklist = response.visible;
                    self.restDownloadRunning = false;
                })
                .catch(function (error) {
                    console.error(error);
                    self.restDownloadRunning = false;
                })
        }

        self.popolateCheckListUpload = function () {
            self.restUploadRunning = true;
            $arcService.uploadDocumentationRichiestaPostVendita(self.richiestePostVendita)
                .then(function (response) {
                    self.listOfDocumentUpload = response.listDocuments;
                    self.visibleUploadChecklist = response.visible;
                    self.message = response.message;
                    self.restUploadRunning = false;
                })
                .catch(function (error) {
                    console.error(error);
                    self.restUploadRunning = false;
                })
        }

        self.validityPage = function (type, validity) {
            switch (type) {

                case 'requestData':
                    self.validation.requestData = validity;
                    break;


                case 'checkList':
                    self.validation.checkListUpload = validity;
                    break;


            }
            self.enableNext = validity;
        }

        self.allegatiChange = function (value) {
            if (self.richiestePostVendita.metadata.variazioneAnagrafica.allegati.length > 0) {
                self.richiestePostVendita.metadata.variazioneAnagrafica.allegati.push(value);
            } else {
                self.richiestePostVendita.metadata.variazioneAnagrafica.allegati[0] = value;
            }
        }

        self.nextValidity = function () {
            var testPage = false;
            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1') {
                testPage = self.validation.checkListUpload
            } else {
                testPage = self.validation.requestData;
            }
            return testPage;
        }

        self.backValidity = function () {
            return (self.getWizardMap(self.richiestePostVendita.viewIndex) !== 'PVA1') || self.richiestePostVendita.readOnly ? true : false;
        }

        self.next = function () {
            self.enabledLoader = true;
            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PVA1') {
                $RichiestePostVenditaService
                    .generateDocumentsPv(RichiestePostVendita.build(self.richiestePostVendita))
                    .then(function (response) {
                        if (response.success) {
                            $RichiestePostVenditaService
                                .nextStepPv(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                                .then(function (response) {
                                    self.enabledLoader = false;
                                    self.richiestePostVendita = response;

                                    if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1') {
                                        retrieveStepInfo();
                                        self.popolateCheckListDownload();
                                        self.popolateCheckListUpload();
                                    }

                                }).catch(function (error) {
                                    console.log(error);
                                    self.enabledLoader = false;
                                });
                        } else {
                            self.enabledLoader = false;
                        }
                    }).catch(function (error) {
                        console.log(error);
                        self.enabledLoader = false;
                    });
            } else if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1') {
                $RichiestePostVenditaService
                    .variazioneAnagSoc(self.richiestePostVendita.metadata.variazioneAnagrafica, self.richiestePostVendita.idWf, self.richiestePostVendita.viewIndex,
                        self.richiestePostVendita.applicationName, self.richiestePostVendita.typeWf)
                    .then(function (response) {
                        if (response.success) {
                            $location.path('/');
                        }
                        self.enabledLoader = false;

                    }).catch(function (error) {
                        console.log(error);
                        self.enabledLoader = false;
                    });
            }
        }

        self.sospendi = function () {
            $RichiestePostVenditaService
                .suspendInstance(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                .then(function () {
                    $location.path('/');
                    $modalService.closeModal("suspendInstance");
                })
        }

        self.back = function () {
            if (self.richiestePostVendita.readOnly) {
                $location.path('/');
            } else {
                $RichiestePostVenditaService
                    .backStepPv(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                    .then(function (response) {
                        self.enabledLoader = false;
                        self.richiestePostVendita = response;
                        retrieveStepInfo();
                    }).catch(function (error) {
                        console.log(error);
                        self.enabledLoader = false;
                    })

            }

        }

        self.closeModal = function () {
            $modalService.closeModal("suspendInstance");
        }

        self.getWizardMap = function (viewIndex) {
            if (
                $rootScope.wizardMap.find(function (element) {
                    return element.index == viewIndex;
                })
            ) {
                return $rootScope.wizardMap.find(function (element) {
                    return element.index == viewIndex;
                }).viewName;
            }
        };

        var retrieveStepInfo = function () {
            self.clearLabelInfo = true;
            $RichiestePostVenditaService
                .getStepInfo(self.richiestePostVendita.id, self.richiestePostVendita.viewIndex)
                .then(function (response) {
                    if (response.success) {
                        self.showMapInfo = response.showBeMessage;
                        self.mapInfo = response.message;
                        self.enabledLoader = false;
                    }
                    self.clearLabelInfo = false;
                })
                .catch(function (error) {
                    console.log(error);
                    self.enabledLoader = false;
                    self.clearLabelInfo = false;
                });
        }
    }
});